import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { navigationAction } from '../redux/slices/navigation';

const UseMobileMenu = () => {
    const dispatch = useAppDispatch();
    const mobileMenuStates = useAppSelector(
        (state) => state.navigation.mobileMenus
    );

    const showMainMenu = (open: boolean) => {
        dispatch(
            navigationAction.setMobileMenuOpen({
                menu: 'main',
                open: open,
            })
        );
    };

    const showProfileMenu = (open: boolean) => {
        dispatch(
            navigationAction.setMobileMenuOpen({
                menu: 'profile',
                open: open,
            })
        );
    };

    const showQuotationMenu = (open: boolean) => {
        dispatch(
            navigationAction.setMobileMenuOpen({
                menu: 'quotation',
                open: open,
            })
        );
    };

    const showSearch = (open: boolean) => {
        dispatch(
            navigationAction.setMobileMenuOpen({
                menu: 'search',
                open: open,
            })
        );
    };

    const showCollectionFilter = (open: boolean) => {
        dispatch(
            navigationAction.setMobileMenuOpen({
                menu: 'filter',
                open: open,
            })
        );
    };

    const closeAllMobileMenu = () => {
        showProfileMenu(false);
        showMainMenu(false);
    };

    return {
        mobileMenuStates,
        closeAllMobileMenu,
        showMainMenu,
        showProfileMenu,
        showSearch,
        showQuotationMenu,
        showCollectionFilter,
    };
};

export default UseMobileMenu;
